import styled from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import { fontTitle } from 'Styles/fonts';
import BaseIcon from '../Icons/Icon';

export const Icon = styled(BaseIcon)``;

export const Fade = styled.div`
  opacity: 0;

  &.fade-enter {
    /* TODO: Keeping animation type as linear for now but will revisit with design to assess usage of cubic-bezier function */
    transition: opacity
      ${({ transitionDurationEnter }) => transitionDurationEnter}ms linear;
    opacity: 0;
  }

  &.fade-enter-active,
  &.fade-enter-done {
    opacity: 1;
  }

  &.fade-exit,
  &.fade-exit-done {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity
      ${({ transitionDurationExit }) => transitionDurationExit}ms linear;
  }
`;

export const Pill = styled.div`
  display: inline-flex;
  padding: 7px 12px;
  border-radius: 16px;
  height: 32px;
  align-items: center;
  color: var(--background);
  background: ${switchProp('variant', {
    default: convertColorToThemeHexCode('blue'),
    dark: convertColorToThemeHexCode('black'),
    light: convertColorToThemeHexCode('grey80'),
    error: convertColorToThemeHexCode('red')
  })};
  cursor: ${ifProp('onClick', 'pointer', 'default')};
  text-transform: capitalize;
  border: none;
  white-space: pre;
  ${fontTitle(14)};

  ${Icon} {
    margin-left: 8px;
  }
`;
